import { useEffect } from 'react';
import { discoveryStore } from '.';
import { currentUserStore } from '../CurrentUser/Store';
import { findLink } from '../LinkyLinky';

function useDiscoveryStore(): void {
  useEffect(() => {
    // Check the state directly instead of computed property
    if (discoveryStore.state.kind === 'discovery-store-loaded') {
      return;
    }
    const link = findLink('discovery-portal', currentUserStore.links);
    link.do(discoveryStore.load);
  }, []); // Remove dependencies since MobX handles reactivity
  return;
}

export default useDiscoveryStore;
